import { useEffect, useState } from "react";

function readCompactShell(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return true;
  }
  return !window.matchMedia("(min-width: 720px)").matches;
}

export function useCompactShell(): boolean {
  const [compact, setCompact] = useState(readCompactShell);

  useEffect(() => {
    const media = window.matchMedia("(min-width: 720px)");
    const update = () => {
      setCompact(!media.matches);
    };
    update();
    media.addEventListener("change", update);
    return () => {
      media.removeEventListener("change", update);
    };
  }, []);

  return compact;
}
